module.exports = __webpack_public_path__ + "public/images/Outschool_Author_Logo.1315316669d6687cc42556a9e75b9bde.webp";